import { QuestionBase } from './question-base.model';

export class FingerprintQuestion extends QuestionBase<string> {
   controlType = 'fingerprint';
   visible: boolean;
   multiple: boolean;
   formatsAllowed: string;
   conditions: any;
   maxSize: number;
   formAction: any;
   id: string;
   formSubmit: boolean;
   crop_image: boolean;
   compress_image: boolean;
   display_image: boolean;
   delete_document: string;
   constructor(options: {} = {}) {
      super(options);
      this.id = options['id'];
      this.conditions = options['conditions'] || '';
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.multiple = options['multiple'];
      this.formatsAllowed = options['formatsAllowed'];
      this.maxSize = options['maxSize'];
      this.formAction = options['formAction'];
      this.formSubmit = (options['formSubmit'] == undefined) ? false : options['formSubmit'];
      this.crop_image = (options['crop_image'] == undefined) ? true : options['crop_image'];
      this.compress_image = (options['compress_image'] == undefined) ? true : options['compress_image'];
      this.delete_document = (options['delete_document'] == undefined) ? "delete" : options['delete_document'];
      this.display_image = (options['display_image'] == undefined) ? false : options['display_image'];
   }
}